// This file contains definitions applied by the webpack DefinePlugin.
// See webpack*.js in this directory for definitions
// See template.env for how to use environment variables for configuration

// Set to 'release' or 'debug'
// Debug builds can be configured at runtime. Access runtime configuration
// by clicking on the version at the bottom of the desktop app's welcome screen.
export const buildType = globalThis.BUILD_TYPE;

// true for a development build compiled locally from source
// false for published CI builds (both debug and release)
export const runningFromSource = globalThis.RUNNING_FROM_SOURCE;

// Set to 'development', 'local', 'test' or 'production'
export const backend = globalThis.BACKEND;

// Set a URL for access to a local API. Only used when backend is local
// If not set http://localhost:8080/v1 is the default
export const localApi = globalThis.LOCAL_API;

// Is set to the package.json version
export const version = globalThis.VERSION_STRING;

// If set, enables Sentry crash reporting from the React code,
// and identifies which Sentry project to upload events to
export const sentryDSN = globalThis.SENTRY_DSN;
export const sentryDist = globalThis.SENTRY_DIST;

// Array of features enabled
export const features = globalThis.FEATURES_ENABLED || [];

export const loginConfiguration = globalThis.LOGIN_CONFIGURATION;

export const liquidNobleApiUrl = globalThis.LIQUID_NOBLE_API_URL;

export const branchApiKey = globalThis.BRANCH_API_KEY;

export const deploymentUrl = globalThis.DEPLOYMENT_URL;

export const stripePublishableKey = globalThis.STRIPE_PUBLISHABLE_KEY;

export const reCaptchaSiteKey = globalThis.RECAPTCHA_SITE_KEY;

export const fbqPixelId = globalThis.FBQ_PIXEL_ID;

export const brandDomain = globalThis.BRAND_DOMAIN;

export const gaMeasurementId = globalThis.GA_MEASRUEMENT_ID;

export const gtmContainerId = globalThis.GTM_CONTAINER_ID;

export const clarityProjectId = globalThis.CLARITY_PROJECT_ID;
